import client from 'providers/fetchClient'

export const getGroups = params => client.get('/beneficiaries-groups', { params })

export const createGroup = data => client.post('/beneficiaries-groups', data)

export const deleteGroup = id => client.delete(`/beneficiaries-groups/${id}`)

export const editGroup = (id, data) => client.patch(`/beneficiaries-groups/${id}`, data)

export const getGroupInfo = id => client.get(`/beneficiaries-groups/${id}`)

export const attributeBeneficiary = (id, data) => client.post(`/beneficiaries-groups/${id}/beneficiaries`, data)

export const beneficiariesAttribution = (id, data) => client.post(`/beneficiaries-groups/${id}/beneficiaries/csv`, data)

export const deleteGroupBeneficiary = (groupID, beneficiaryID) =>
  client.delete(`beneficiaries-groups/${groupID}/beneficiaries/${beneficiaryID}`)

export const activateGroup = (id, action) => client.put(`/beneficiaries-groups/${id}/${action}`)
